export default __webpack_public_path__ + "media/images/react_icons/faq-c22825ed632b0f8843384f285b830d7f.svg";